import _ from 'lodash';
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { from, Observable, of, throwError } from 'rxjs';
import { map, catchError, switchMap, first } from 'rxjs/operators';
import { ToastService } from 'app/toast/services/toast.service';
import { ERRORS } from 'app/virtual-event/virtual-event.enums';
import { LoadingService } from '../services/loading.service';
import { TransformService } from '../services/transform.service';
import { ModalLoginService } from 'app/router-wrapper/services/modal-login/modal-login.service';
import { Router } from '@angular/router';
import { AuthService } from 'app/router-wrapper/services/auth/auth.service';
import { BulkCheckoutService } from 'app/event/services/bulk-checkout.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  public errors: any[] = [{

  }];

  constructor(
    private authService: AuthService,
    private router: Router,
    private modalLoginService: ModalLoginService,
    private transformService: TransformService,
    private loadingService: LoadingService,
    private toastService: ToastService,
    private bulkCheckoutService:BulkCheckoutService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if(this.loadingService.enabled) {
      this.loadingService.loading = true;
    }
    if(this.bulkCheckoutService.isBulkCheckout){
     return next.handle(request).pipe(
      catchError((response) => {
        return throwError(response);
      }))
    }

    return next.handle(request).pipe(
      map((event: any) => {
        if (event instanceof HttpResponse) {
          const { body } = event;
          if(_.has(body, 'error')) {
            const { error } = body;
            if(_.isEmpty(error.errorMessage)) {
              error.errorMessage = _.get(ERRORS, error.debugInfo, 'Server Error');
            }
            throw new HttpErrorResponse({
              error: body.error,
              headers: event.headers,
              status: 500,
              statusText: 'Server Error',
              url: event.url
            });
          } else {
            const track = request.url == "/api/org/login/switch" ? false : this.authService.track;
            if(window['orgSignIn']) {
              window['orgSignIn'].extendCookieLife(track);
            }
          }
          if(this.loadingService.transform) {
            (<any>event.body) = this.transformService.transform(body);
          }
          this.loadingService.loading = false;
        }
        return event;
      }),
      catchError((response) => {
        this.loadingService.loading = false;
        const { error } = response;
        if(error.errorCode === "InvalidAccessToken" && request.url !== "/api/org/loginAs") {
          const modalRef = this.modalLoginService.open();
          return modalRef.onClose.pipe(
            first(),
            switchMap(() => {
              const p = this.router.navigate(['empty-page'], {
                skipLocationChange: true
              }).then(()=> {
                return this.router.navigateByUrl(this.authService.url);
              });
              return from(p)
            }),
            map(value => {
              return throwError(value);
            })
          )
        }
        if(response.status === 413) {
          this.toastService.show('danger', 'File size cannot be more than 5MB', {delay: 5000})
        } else {
          switch(error.debugInfo) {
            case 'UserInNotAdmin':
              error.errorMessage = "User is not admin";
              return throwError(error);
            case 'InvalidAccessToken':
            case 'InvalidPassword':
            case 'UserAlreadyExist':
            case 'OrgAccountBlocked':
              error.errorMessage = "Account Blocked";
              return throwError(error);
            case 'OrgAccountClosed':
              error.errorMessage = "Account Closed";
              return throwError(error);
            case 'NonOrgUser':
            case 'NothingToUpdate':
            case 'HandleAlreadyExist':
            case 'InvalidTaxId':
            case 'InvalidEmail':
            case 'UserDoesNotExist':
            case 'InvalidLast4SSN':
            case 'InvalidCoupon':
            case 'CouponNotYetActive':
            case 'CouponExpired':
            case 'RedeemedTooManyTimes':
            case 'InvalidUrl':
            case 'WebhookSendError':
            case 'NoDonorNotes':
            {
              return throwError(error);
            }
          }
          let errorMessage = error.errorMessage || "Sorry! something has gone wrong, please try again.";
          if(error.errorCode === "TicketSoldOut") {
            errorMessage = "Ticket Sold Out.";
          }
          if(error.errorCode == "ValidationError") {
            errorMessage = "Session Expired, refresh the page and try again...";
          }
          if(error.errorCode == "NoWinnerFound") {
            errorMessage = "No allocations have been made";
          }
          if(error.errorCode == "UserPasswordNotSet") {
            errorMessage = "User Password Not Set.";
          }
          if(error.errorCode == "OrgUser") {
            errorMessage = "Email in use as primary org user. Please use different email id.";
          }
          
          this.toastService.show('danger', errorMessage, {delay: 5000})
        }
        return throwError(response);
      })
    )
  }

}
